import React from 'react'
import ImgUtil from '../../../../utils/img.utils'
import { HeroOuter } from './style'

// Components
import Typography from '../../../global/typography'

// Helpers
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'
import WrapperImage from '../../../global/wrapperImage'

const FormPageHero = (props: any) => {
  if (props) {
    const onClick = (e: any) => {
      e.preventDefault()
      let target = document.querySelector('#AR-WP__Form')
      target && target.scrollIntoView()
      return false
    }

    let webinarHeroType
    if (props.webinarHeroType) {
      webinarHeroType = props.webinarHeroType
    }

    return (
      <HeroOuter
        data-cy="FormPageHero"
        heroTextCentered={props.heroTextCentered}
        heroFontBlack={props.heroFontBlack}
        webinarHeroType={webinarHeroType}
        isWebinar={props.isWebinar ? props.isWebinar : false}>
        {props.image?.imageSrc && (
          <WrapperImage
            src={ImgUtil.getResizedImageUrl(props.image.imageSrc, ``)}
            alt={props.image?.imageAlt}
            className="Hero__Main-Img"
            width={940}
            height={940}
            threshold={650}
          />
        )}
        <div className="Hero__Container">
          <div className="Hero__Container-Text">
            {props.heroEyebrow && <h5 className="Hero__Eyebrow">{props.heroEyebrow}</h5>}
            {props.h1Title && (
              <h1 className="Hero__Title" dangerouslySetInnerHTML={{ __html: props.h1Title }}></h1>
            )}
            {props.heroSubtitle && (
              <p className="Hero__Subtitle">{formatInlineCode(props.heroSubtitle)}</p>
            )}
            {props.heroBullet && (
              <Typography className="Hero__List" type="bodyXSWrapper">
                {renderRichText(props.heroBullet)}
              </Typography>
            )}
            {!props.heroTextCentered && !props.isWebinar && props.hasForm && (
              <a onClick={onClick} className="Hero__Mobile-CTA">
                See How
              </a>
            )}
          </div>
        </div>
      </HeroOuter>
    )
  }
  return null
}

export default FormPageHero
